const useWeeklyStyles = ({
  dayWrapper: {
    position: 'relative',
  },
  day: {
    width: 36,
    height: 36,
    fontSize: 'caption.fontSize',
    margin: '0 2px',
    color: 'inherit',
  },
  customDayHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '2px',
    right: '2px',
    border: '1px solid secondary.main',
    borderRadius: '50%',
  },
  nonCurrentMonthDay: {
    color: 'text.disabled',
  },
  highlightNonCurrentMonthDay: {
    color: 'text.disabled',
  },
  highlight: {
    backgroundColor: 'primary.main',
    color: 'common.white',
    '& .MuiPickersDay-root': {
      backgroundColor: 'primary.main',
      '&:hover, &:focus': {
        backgroundColor: 'primary.dark',
      },
    },
  },
  firstHighlight: {
    extend: 'highlight',
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  },
  betweenHighlight: {
    borderRadius: '0%',
  },
  endHighlight: {
    extend: 'highlight',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderTopLeftRadius: '0%',
    borderBottomLeftRadius: '0%',
  },
});

export default useWeeklyStyles;
